export default function CommentsSection() {
  return (
    <section id="comments" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              用户评价
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              听听追剧小伙伴们怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 md:col-span-2">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20portrait%20avatar%20with%20soft%20coral%20orange%20gradient%20background%2C%20minimalist%20style%2C%20friendly%20and%20approachable%20feel%2C%20clean%20composition&width=120&height=120&seq=douhua-avatar-1&orientation=squarish"
                    alt="追剧小达人"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">追剧小达人</div>
                  <div className="text-xs text-foreground-500">2天前</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                豆花视频真的太好用了！把香蕉视频和蜜桃视频的内容整合在一起，再也不用装好几个应用了。《繁花似锦》追得根本停不下来，画质清晰还不卡，强烈推荐！
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-3-line text-primary-500"></i>
                <span>328</span>
              </div>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20portrait%20avatar%20with%20soft%20amber%20golden%20gradient%20background%2C%20minimalist%20style%2C%20creative%20and%20expressive%20feel%2C%20clean%20composition&width=120&height=120&seq=douhua-avatar-2&orientation=squarish"
                    alt="电影爱好者"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">电影爱好者</div>
                  <div className="text-xs text-foreground-500">3天前</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                作为一个电影重度用户，豆花视频的更新速度真的让我惊喜。红桃视频刚上的新片这里就能找到，省了好多找资源的时间。希望平台越来越好！
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-3-line text-primary-500"></i>
                <span>256</span>
              </div>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20portrait%20avatar%20with%20soft%20peach%20pink%20gradient%20background%2C%20minimalist%20style%2C%20elegant%20and%20gentle%20feel%2C%20clean%20composition&width=120&height=120&seq=douhua-avatar-3&orientation=squarish"
                    alt="古装迷妹"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">古装迷妹</div>
                  <div className="text-xs text-foreground-500">5天前</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                《长安锦绣》的服化道绝了！感谢豆花视频让我发现了这部好剧。蜜桃视频的内容质量真的没话说，每天更新也很及时，良心平台！
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-3-line text-primary-500"></i>
                <span>189</span>
              </div>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20portrait%20avatar%20with%20soft%20muted%20coral%20gradient%20background%2C%20minimalist%20style%2C%20calm%20and%20thoughtful%20feel%2C%20clean%20composition&width=120&height=120&seq=douhua-avatar-4&orientation=squarish"
                    alt="深夜追剧人"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">深夜追剧人</div>
                  <div className="text-xs text-foreground-500">6天前</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                樱桃视频的悬疑剧太好看了！《迷雾追踪》熬夜刷完8集，剧情反转到我怀疑人生。豆花视频的搜索功能也很好用，想看什么直接搜就行。
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-3-line text-primary-500"></i>
                <span>142</span>
              </div>
            </div>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20simple%20warm%20toned%20abstract%20portrait%20avatar%20with%20soft%20warm%20golden%20gradient%20background%2C%20minimalist%20style%2C%20family%20friendly%20and%20cheerful%20feel%2C%20clean%20composition&width=120&height=120&seq=douhua-avatar-5&orientation=squarish"
                    alt="全家观影团"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">全家观影团</div>
                  <div className="text-xs text-foreground-500">1周前</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                家里有小孩，糖豆视频的亲子内容区真是帮了大忙。豆花视频把不同平台的内容分得很清楚，找动画片和纪录片都很方便。全家人都能找到喜欢的！
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-heart-3-line text-primary-500"></i>
                <span>97</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}